module.exports = __webpack_public_path__ + "c20e93f0009d151d17ebf2834eb3dba4.jpg";